import { Component, OnInit } from '@angular/core';
import cssVars from 'css-vars-ponyfill';
import { GetUrlParameters } from './utils';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  showDForm = false;

  ngOnInit() {
    // IE11 fix for CSS Variables
    cssVars({});

    const urlParameters = GetUrlParameters();
    if (urlParameters.dform) {
      this.showDForm = true;
    }

    switch (urlParameters.subChannel) {
      // Edison
      case 'ed01':
        this.setThemeEdison();
        break;
      // Aria web
      case 'ar02':
        this.setThemeAria();
        break;
      // MiNet
      case 'MiNet':
        this.setThemeMiNet();
        break;
      // Vision is the default
      default:
        this.setThemeAria();
    }
  }

  private setThemeEdison() {
    const themeNameValues = {
      '--main-bg-color': '#ffffff',
      '--header-bg-color': '#4d5256',
      '--header-brand-bg-color': '#4d5256',
      '--header-brand-to-bg-color': '#4d5256',
      '--main-btn-bg-color': '#f8b134',
      '--main-btn-hover-bg-color': '#f8b134',
      '--second-btn-bg-color': '#f8b134',
      '--second-btn-hover-bg-color': '#f8b134',
      '--bot-message-bg-color': '#f5f5f5',
      '--user-message-bg-color': '#4d5256',
      '--timestamp-color': '#4d5256',
      '--default-text-color': '#4d5256',
      '--second-text-color': '#ffffff',
      '--default-btn-border-color': '#002855',
      '--default-input-textbox-bg-color': '#d3d2cf',
      '--header-text-color': 'black',
      '--label-border-color': '#f8b134'
    };
    Object.keys(themeNameValues).forEach((nameValue) => {
      document.documentElement.style.setProperty(nameValue, themeNameValues[nameValue]);
    });
  }

  private setThemeMiNet() {
  }

  private setThemeAria() {
    const themeNameValues = {
      '--main-bg-color': '#F4F8FC',
      '--header-bg-color': '#ffffff',
      '--header-brand-bg-color': '#ffffff',
      '--header-brand-to-bg-color': '#ffffff',
      '--header-border': '0.5px solid lightgray',
      '--main-btn-bg-color': '#007DBA',
      '--main-btn-hover-bg-color': '#007dba',
      '--second-btn-bg-color': ' #f8b134',
      '--second-btn-hover-bg-color': '#007dba',
      '--bot-message-bg-color': '#FFFFFF',
      '--user-message-bg-color': '#007DBA',
      '--timestamp-color': '#72879E',
      '--default-text-color': '#002855',
      '--second-text-color': 'white',
      '--default-btn-border-color': '#d3d3d3',
      '--default-input-textbox-bg-color': '#d3d2cf',
      '--header-text-color': 'black',
      '--label-border-color': '#6695c7'
    };
    Object.keys(themeNameValues).forEach((nameValue) => {
      document.documentElement.style.setProperty(nameValue, themeNameValues[nameValue]);
    });
  }

}
